<template>
  <v-flex class="location select" :class="{ 'app-toolbar px-2': app }">
    <!-- z-index 300 to cater for safari bug -->
    <v-autocomplete
      @change="handleChange"
      @focus="handleFocus"
      :label="label"
      v-model="selected"
      :style="toFront ? 'z-index: 300' : ''"
      color="primary"
      :search-input.sync="searchTerm"
      :placeholder="searchTerm"
      :disabled="disabled"
      :required="required"
      :rules="rules || []"
      :loading="loading || fetching"
      :items="options"
      item-value="id"
      :hint="hint"
      append-icon=""
      return-object
      hide-no-data
      no-filter
      clearable
      :solo="solo"
      :attach="attach"
      :dense="dense"
      :hide-details="hideDetails"
      ref="autocomplete"
      @blur="$emit('blur')"
      @keyup.enter="$emit('keyup.enter')"
    >
      <template slot="item" slot-scope="{ item: location }">
        <v-list-tile-avatar v-if="$vuetify.breakpoint.smAndUp && !dense">
          <v-icon>mdi-map-marker</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content v-if="location.address">
          <v-list-tile-title>
            <span>
              {{ location.address }}
            </span>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
      <template slot="selection" slot-scope="{ item: location }">
        <slot name="selection" v-bind:location="location">
          <div :class="{ 'caption selection--dense': dense }">
            <v-avatar v-if="$vuetify.breakpoint.smAndUp" :small="dense">
              <v-icon>mdi-map-marker</v-icon>
            </v-avatar>
            <span
              v-if="location.address"
              class="selection-text"
              :style="`max-width: ${$vuetify.breakpoint.xsOnly ? '90%' : '80%'};`"
            >
              {{ location.address }}
            </span>
          </div>
        </slot>
      </template>
    </v-autocomplete>
  </v-flex>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  created() {
    if (this.value) {
      this.selected = { id: Number(this.value), address: 'Loading…', country: 'Loading…' }
      this.$http.get(`locations/${this.value}`).then(({ data }) => (this.selected = data))
    }
  },

  props: {
    app: { type: Boolean, default: () => false },
    attach: { type: Boolean, default: true },
    autofocus: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disabled: Boolean,
    hideDetails: { type: Boolean, default: false },
    hint: { type: String },
    label: { type: String, default: () => 'Enter a city' },
    loading: { type: Boolean, default: () => false },
    required: Boolean,
    rules: Array,
    solo: { type: Boolean, default: false },
    toFront: { type: Boolean, default: () => true },
    value: { type: [String, Number], default: () => '' },
    coordinates: { type: Boolean, default: false },
  },

  data() {
    return {
      selected: {},
      fetching: false,
      searchTerm: '',
      locations: [],
    }
  },

  computed: {
    options() {
      const locations = _.get(this, 'locations[0]') ? this.locations : []

      if (_.get(this, 'selected.id')) return [this.selected, ...locations]

      return locations
    },
  },

  watch: {
    searchTerm: _.debounce(function(search) {
      this.$emit('search', search)
      // search is null on initial load
      if (search && search.length > 2) {
        this.search()
      } else {
        this.locations = []
      }
    }, 300),
    value(newValue) {
      if (newValue == '') this.selected = {}
    },
  },

  methods: {
    handleChange(selected) {
      if (selected && selected.id) {
        this.selected = selected
        this.$emit(
          'input',
          this.coordinates
            ? `${this.selected.coordinates.lat},${this.selected.coordinates.lon}`
            : `${this.selected.id}`
        )
      } else {
        this.selected = {}
        this.$emit('input', '')
      }
    },

    handleFocus() {
      this.$emit('focus')
    },

    search() {
      this.fetching = true
      const params = { search: this.searchTerm }

      this.$http
        .get('search/locations', { params })
        .then(({ data }) => {
          this.locations = data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => (this.fetching = false))
    },
  },
}
</script>

<style lang="scss">
.location.select {
  &.app-toolbar {
    width: 30rem;
    max-width: 60vw;

    .v-input__slot {
      margin: auto;
      overflow: hidden;
      width: 100%;
    }
  }

  .selection-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selection--dense {
    display: table;
    vertical-align: middle;
    max-width: 99%;
    // margin: 0.1rem 0;

    * {
      display: table-cell;
      vertical-align: middle;
      padding: 0px;
    }
  }

  .v-select__selections {
    max-width: 90%;
  }

  .v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    border-radius: 4px !important;
    border: 1px solid #ebebeb !important;
  }
}
</style>
